import React from 'react';
import { ShieldCheck, Lock, Download, Star, Flame } from 'lucide-react';
import { motion } from 'framer-motion';
import { SectionReveal } from './SectionReveal';
export function Hero() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-12 pb-12 md:pt-16 md:pb-16 bg-[#0a0a0a] border-b border-[#262626]" data-id="element-103">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center" data-id="element-104">
        <SectionReveal data-id="element-105">
          <div className="inline-flex items-center gap-2 border border-[#F59E0B]/30 bg-[#F59E0B]/10 text-[#F59E0B] font-heading text-[10px] md:text-xs tracking-[0.2em] px-3 py-1 rounded-sm mb-4" data-id="element-106">
            <span className="text-sm" data-id="element-107">🔧</span>
            PARA CONDUCTORES CANSADOS DE NO ENTENDER SU AUTO
          </div>

          {/* TITLE */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[0.95] mb-3 text-white" data-id="element-108">
            Mecánica Básica{' '}
            <span className="text-[#F59E0B]" data-id="element-109">Para No Mecánicos</span>
          </h1>

          {/* SUBTITLE */}
          <p className="text-lg md:text-xl text-[#F5F5F5] font-medium mb-2 max-w-3xl mx-auto leading-snug" data-id="element-110">
            Dejá de depender de otros para entender tu vehículo.
          </p>

          {/* Tagline */}
          <p className="text-sm md:text-base text-[#9CA3AF] mb-6 max-w-2xl mx-auto" data-id="element-111">
            Fácil de entender, sin necesidad de saber nada de mecánica.
          </p>
        </SectionReveal>

        {/* MOCKUP — centered after the tagline */}
        <SectionReveal delay={0.2} className="relative max-w-md md:max-w-lg mx-auto mb-6" data-id="element-112">
          <div className="relative" data-id="element-113">
            {/* Floating product image */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 5,
            ease: 'easeInOut',
            repeat: Infinity
          }} className="relative" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/aV4PhqQBtjBJveGkQxbN2F/ChatGPT_Image_4_jun_2026,_12_20_53.png" alt="MegaPack Mecánica Básica Para No Mecánicos — 6 Tomos + 6 Bonos Exclusivos" loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto drop-shadow-[0_25px_50px_rgba(0,0,0,0.8)]" data-id="element-115" />
            </motion.div>

            {/* Floating badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.5,
            rotate: -20
          }} animate={{
            opacity: 1,
            scale: 1,
            rotate: -8
          }} transition={{
            delay: 0.8,
            type: 'spring',
            stiffness: 200
          }} className="absolute top-2 right-2 md:top-4 md:right-4 bg-[#DC2626] text-white font-heading font-bold px-3 py-2 rounded-full shadow-2xl border-4 border-[#0a0a0a] text-center leading-none" data-id="element-116">
              <div className="text-[9px] tracking-widest" data-id="element-117">PACK</div>
              <div className="text-xl" data-id="element-118">100%</div>
              <div className="text-[9px] tracking-widest" data-id="element-119">DIGITAL</div>
            </motion.div>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.25} data-id="element-120">
          {/* Rating + Social Proof — compact inline */}
          <div className="inline-flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-5 px-4 py-2 bg-[#171717] border border-[#262626] rounded-sm" data-id="element-121">
            <div className="flex items-center gap-2" data-id="element-122">
              <div className="flex gap-0.5" data-id="element-123">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#F59E0B] text-[#F59E0B]" data-id="element-124" />)}
              </div>
              <span className="text-white font-heading font-bold text-sm" data-id="element-125">
                4.9/5
              </span>
            </div>
            <div className="w-px h-4 bg-[#262626]" data-id="element-126"></div>
            <div className="flex items-center gap-1.5 text-xs text-[#F5F5F5]" data-id="element-127">
              <motion.div animate={{
              scale: [1, 1.15, 1]
            }} transition={{
              duration: 1.5,
              repeat: Infinity
            }} data-id="element-128">
                <Flame className="w-3.5 h-3.5 text-[#DC2626] fill-[#DC2626]" data-id="element-129" />
              </motion.div>
              <span className="font-medium" data-id="element-130">
                <span className="text-[#F59E0B] font-bold" data-id="element-131">65 conductores</span>{' '}
                compraron hoy
              </span>
            </div>
          </div>

          <div data-id="element-132">
            <button onClick={scrollToOffer} className="w-full sm:w-auto bg-[#F59E0B] hover:bg-[#D97706] text-[#0a0a0a] font-heading font-bold text-lg md:text-xl px-8 py-4 rounded-sm tracking-wider transition-all hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] inline-flex items-center justify-center gap-3" data-id="element-133">
              🚀 ¡SÍ, QUIERO EL MEGAPACK!
            </button>
          </div>

          <div className="mt-3 flex flex-wrap justify-center items-center gap-x-4 gap-y-1 text-xs text-[#9CA3AF] font-medium" data-id="element-134">
            <span className="flex items-center gap-1.5" data-id="element-135">
              <Lock className="w-3 h-3" data-id="element-136" /> Pago único
            </span>
            <span className="hidden sm:inline text-[#262626]" data-id="element-137">•</span>
            <span className="flex items-center gap-1.5" data-id="element-138">
              <Download className="w-3 h-3" data-id="element-139" /> Acceso inmediato
            </span>
            <span className="hidden sm:inline text-[#262626]" data-id="element-140">•</span>
            <span className="flex items-center gap-1.5" data-id="element-141">
              <ShieldCheck className="w-3 h-3" data-id="element-142" /> Garantía 7 días
            </span>
          </div>

          {/* Secure payment badges */}
          <div className="mt-5 inline-flex flex-col items-center gap-2 px-5 py-3 bg-[#171717] border border-[#262626] rounded-sm" data-id="element-143">
            <div className="flex items-center gap-1.5 text-[#F5F5F5] text-xs font-medium" data-id="element-144">
              <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" data-id="element-145" />
              <span data-id="element-146">Compra 100% Segura · Procesado por:</span>
            </div>
            <div className="flex items-center gap-2 flex-wrap justify-center" data-id="element-147">
              <div className="bg-[#00B1EA] text-white font-bold text-[10px] px-2 py-1 rounded-sm tracking-tight leading-none flex items-center gap-1" data-id="element-148">
                <span className="text-yellow-300" data-id="element-149">●</span>
                MercadoPago
              </div>
              <div className="bg-white text-[#1A1F71] font-bold italic text-[11px] px-2 py-1 rounded-sm leading-none" data-id="element-150">
                VISA
              </div>
              <div className="bg-white text-[#1A1F71] font-bold text-[10px] px-2 py-1 rounded-sm leading-none flex items-center gap-0.5" data-id="element-151">
                <span className="text-[#EB001B]" data-id="element-152">●</span>
                <span className="text-[#F79E1B] -ml-1" data-id="element-153">●</span>
                <span className="ml-0.5 tracking-tighter" data-id="element-154">mastercard</span>
              </div>
              <div className="bg-[#006FCF] text-white font-bold text-[9px] px-2 py-1 rounded-sm tracking-tight leading-none" data-id="element-155">
                AMEX
              </div>
            </div>
          </div>
        </SectionReveal>
      </div>
    </section>;
}